import { isElevatedRole } from "./roles";
import type { UserProfile } from "@/types/auth";

const DISABLE_AUTH = import.meta.env.VITE_DISABLE_AUTH === "true";

export function canAccessInternalAdsTools(
	userProfile: Pick<UserProfile, "email" | "platform_role"> | null | undefined,
): boolean {
	if (DISABLE_AUTH) return true;

	const platformRole = userProfile?.platform_role;
	if (isElevatedRole(platformRole) || platformRole === "expert") {
		return true;
	}

	return userProfile?.email?.toLowerCase().endsWith("@agileandco.com") ?? false;
}

/**
 * Admin gate — delegates to the shared isElevatedRole predicate (platform
 * role only, NO email allowlist). Use for links into /admin so visibility
 * matches access and non-admins don't hit an "Admin Access Required" dead-end.
 */
export function canAccessAdmin(
	userProfile: Pick<UserProfile, "platform_role"> | null | undefined,
): boolean {
	return isElevatedRole(userProfile?.platform_role);
}
